<template>
  <form id="item_form" @submit.prevent="validate">
    <div class="md-layout">
      <div class="md-layout-item md-size-45 md-layout md-alignment-center">
        <div class="md-layout-item md-size-35">
          <label class="md-form-label">Familia</label>
        </div>
        <div class="md-layout-item md-size-65">
          <md-field :class="validationClass('familyId')">
            <label for="familyId">Familia</label>
            <md-select v-model="supplyFamily" name="familyId" :disabled="isCopy" id="familyId">
              <md-option :value="c.id" v-for="c in families" :key="c.id">{{ c.name }}</md-option>
            </md-select>
          </md-field>
        </div>
      </div>

      <div class="md-layout-item md-size-50 md-layout md-alignment-center">
        <div class="md-layout-item md-size-35">
          <label class="md-form-label">Sub Familia</label>
        </div>
        <div class="md-layout-item md-size-65">
          <md-field>
            <label for="supplySubFamily">Sub Familia</label>
            <md-select
              v-model="supplySubFamily"
              name="supplySubFamily"
              id="supplySubFamily"
              :disabled="isCopy"
            >
              <md-option :value="c.id" v-for="c in selectableSubFamilies" :key="c.id">{{ c.name }}</md-option>
            </md-select>
          </md-field>
        </div>
      </div>
    </div>

    <div class="md-layout md-alignment-center">
      <label class="md-layout-item md-size-35 md-form-label">Nombre de Insumo</label>
      <div class="md-layout-item md-size-65">
        <md-field :class="validationClass('name')">
          <md-input
            data-vv-name="name"
            v-validate="modelValidations.name"
            v-model="updatedItem.name"
            type="text"
            name="updatedItem.name"
          ></md-input>
          <span class="md-helper-text">Nombre de Insumo</span>
          <error-indicator :valid="validField('name')"></error-indicator>
        </md-field>
      </div>
    </div>

    <div class="md-layout md-alignment-center">
      <label class="md-layout-item md-size-35 md-form-label">Código de Insumo</label>
      <div class="md-layout-item md-size-65">
        <md-field>
          <label>Se Genera Automáticamente</label>
          <md-input disabled v-model="updatedItem.code" type="text" name="updatedItem.code"></md-input>
          <span class="md-helper-text">Código de Insumo</span>
        </md-field>
      </div>
    </div>

    <div class="md-layout md-alignment-center">
      <label class="md-layout-item md-size-35 md-form-label">Codigo SCT</label>
      <div class="md-layout-item md-size-65">
        <md-field :class="validationClass('sctCode')">
          <md-input
            data-vv-name="sctCode"
            v-validate="modelValidations.sctCode"
            v-model="updatedItem.sctCode"
            type="text"
            :disabled="isCopy"
            name="updatedItem.sctCode"
          ></md-input>
          <span class="md-helper-text">Codigo SCT</span>
          <error-indicator :valid="validField('sctCode')"></error-indicator>
        </md-field>
      </div>
    </div>

    <div class="md-layout md-alignment-center">
      <div class="md-layout-item md-size-35">
        <label for="updatedItem.isDivisible">¿Es divisible?</label>
      </div>
      <div class="md-layout-item md-size-65">
        <md-switch v-model="updatedItem.isDivisible" :disabled="isCopy"></md-switch>
      </div>
    </div>

    <div class="md-layout md-alignment-center">
      <div class="md-layout-item md-size-35">
        <label class="md-form-label">Unidad de Medida</label>
      </div>
      <div class="md-layout-item md-size-65">
        <md-field :class="validationClass('unitMeasurementId')">
          <label for="updatedItem.unitMeasurementId">Unidad de Medida</label>
          <md-select
            data-vv-name="unitMeasurementId"
            v-validate="modelValidations.unitMeasurementId"
            v-model="updatedItem.unitMeasurementId"
            name="updatedItem.unitMeasurementId"
            id="updatedItem.unitMeasurementId"
          >
            <md-option :value="c.id" v-for="c in mMeass" :key="c.id" required>{{ c.name }}</md-option>
          </md-select>
          <error-indicator :valid="validField('unitMeasurementId')"></error-indicator>
        </md-field>
      </div>
    </div>

    <div class="md-layout md-alignment-center">
      <div class="md-layout-item md-size-35">
        <label class="md-form-label">Tipo de Insumo</label>
      </div>
      <div class="md-layout-item md-size-65">
        <md-field :class="validationClass('supplyTypeId')">
          <label for="updatedItem.supplyTypeId">Tipo de Insumo</label>
          <md-select
            data-vv-name="supplyTypeId"
            v-validate="modelValidations.supplyTypeId"
            v-model="updatedItem.supplyTypeId"
            name="updatedItem.supplyTypeId"
            id="updatedItem.supplyTypeId"
          >
            <md-option :value="c.id" v-for="c in mSupplyType" :key="c.id" required>{{ c.name }}</md-option>
          </md-select>
          <error-indicator :valid="validField('supplyTypeId')"></error-indicator>
        </md-field>
      </div>
    </div>

    <div class="md-layout md-alignment-center">
      <label class="md-layout-item md-size-35 md-form-label">Peso Volumétrico</label>
      <div class="md-layout-item md-size-65">
        <md-field :class="validationClass('unitWeight')">
          <md-input
            :disabled="isCopy"
            data-vv-name="unitWeight"
            v-validate="modelValidations.unitWeight"
            v-model="updatedItem.unitWeight"
            type="number"
            name="updatedItem.unitWeight"
          ></md-input>
          <span class="md-suffix">Kg</span>
          <span class="md-helper-text">Peso Volumétrico (KG)</span>
          <error-indicator :valid="validField('unitWeight')"></error-indicator>
        </md-field>
      </div>
    </div>

    <div class="md-layout md-alignment-center">
      <label class="md-layout-item md-size-35 md-form-label">Comentario sobre Insumo</label>
      <div class="md-layout-item md-size-65">
        <md-field :class="validationClass('comment')">
          <md-textarea v-model="updatedItem.comment"></md-textarea>
          <error-indicator :valid="validField('comment')"></error-indicator>
        </md-field>
      </div>
    </div>

    <image-field :editedObject="updatedItem" fieldName="image" />

    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <h3>Pictogramas:</h3>
      </div>
      <md-field class="md-layout-item md-size-40 buttons-style">
        <md-button class="md-success md-round md-fileinput">
          <!-- No hay Imagen -->
          <template v-if="!showImgs">Cargar imagenes</template>
          <!-- Si hay Imagen -->
          <template v-else>Agregar imagenes</template>
          <input ref="files" type="file" @change="onFileChange" multiple />
        </md-button>
      </md-field>
      <md-field class="md-layout-item md-size-100 buttons-style">
        <Matrix :images="showImgs">
          <template slot="image-actions" slot-scope="{ image: photo, index }">
            <md-button
              @click="rejectImg(photo, index)"
              class="md-just-icon md-round reject"
              :class="{
                'md-danger': mapRejected.includes(photo.id),
                'md-secondary': !mapRejected.includes(photo.id),
              }"
            >
              <md-icon>close</md-icon>
              <md-tooltip class="md-primary">Presione el boton para rechazar la foto</md-tooltip>
            </md-button>
          </template>
        </Matrix>
      </md-field>
    </div>
  </form>
</template>

<script>
import ImageField from "@/components/Inputs/ImageField";
import Matrix from "@/pages/RoadSinisters/File/Lifting/Matrix.vue";
import { validateImageData } from "@/utils";

const modelValidations = {
  businessLine: {
    required: true,
  },
  name: {
    required: true,
  },
  sctCode: {
    required: true,
    // max: 3
  },
  unitMeasurementId: {
    required: true,
  },
  supplyTypeId: {
    required: true,
  },
  unitWeight: {
    required: true,
  },
};

export default {
  name: "SupplyForm",

  components: {
    ImageField,
    Matrix,
  },

  props: {
    isRegister: Boolean,
    editedItem: {
      type: Object,
      required: true,
    },
    supply: {
      type: Object,
      required: true,
    },
    family: {
      type: [Number, undefined],
      required: false,
    },
    sFamily: {
      type: [Number, undefined],
      required: false,
    },
    families: {
      type: Array,
      required: true,
    },
    subFamilies: {
      type: Array,
      required: true,
    },
    mMeass: {
      type: Array,
      required: true,
    },
    mSupplyType: {
      type: Array,
      required: true,
    },
  },

  methods: {
    rejectImg(img, index) {
      if (img.id) {
        if (!this.mapRejected.includes(img.id)) {
          this.mapRejected.push(img.id);
        } else {
          this.mapRejected.splice(this.mapRejected.indexOf(img.id), 1);
        }
      } else {
        this.localFiles.splice(index, 1);
      }
    },
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      this.uploadFiles(files);
    },
    uploadFiles(files) {
      for (const file of files) {
        validateImageData(file, false).then((image) => {
          this.localFiles.push(image);
        });
      }
    },
    onImageChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      const reader = new FileReader();
      reader.onload = (e) => {
        generatedFile = e.target.result;
        this.updatedItem.image = files[0];
      };
      reader.readAsDataURL(files[0]);
    },

    validate() {
      const updatedItem = {
        rejectedPictograms: this.mapRejected,
        newPictograms: this.localFiles
          ? this.localFiles.reduce((arr, p) => {
              if (!p.id) arr.push(p);
              return arr;
            }, [])
          : [],
        ...this.updatedItem,
      };
      const original = this.editedItem;

      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          updatedItem.subFamilyId = this.supplySubFamily;
          this.$emit("saved", { original, updated: updatedItem });
        } else {
          this.$notify({
            message: "Llene Todos los campos Marcados",
            icon: "close",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "warning",
          });
        }
      });
    },
  },

  mounted() {
    this.updatedItem = { ...this.editedItem };
    this.localFiles =
      this.updatedItem && this.updatedItem.pictograms
        ? [...this.updatedItem.pictograms]
        : [];
    this.watchTouched({ supply: Object.keys(this.modelValidations) });
  },

  computed: {
    showImgs() {
      return this.localFiles;
    },
    selectableSubFamilies() {
      let { supplyFamily, subFamilies } = this;
      if (supplyFamily) {
        subFamilies = subFamilies.filter((sub) => sub.family === supplyFamily);
      }

      return subFamilies;
    },
    isCopy() {
      return !!this.editedItem.originalSupply;
    },
  },

  watch: {
    supplyFamily(value) {
      const { selectableSubFamilies } = this;
      if (selectableSubFamilies.map(({ id }) => id).includes(value)) {
        this.supplySubFamily = null;
      }
    },
    family: {
      immediate: true,
      handler(value) {
        if (value) {
          this.supplyFamily = value;
        }
      },
    },
    sFamily: {
      immediate: true,
      handler(value) {
        if (value) {
          this.supplySubFamily = value;
        }
      },
    },
  },

  data() {
    return {
      modelValidations,
      updatedItem: {},
      supplyFamily: 0,
      supplySubFamily: 0,
      localFiles: [],
      toShow: [],
      mapRejected: [],
    };
  },
};
</script>
<style scoped>
.buttons-style:after {
  height: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Catalogs/Supplies/Existence/SupplyForm.vue